import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import Layout from 'ui-components/components/organisms/AppLayout'

const Explore: FC<{
  slots: {
    Header: FC
    CategoryMaps: FC
    Footer: FC
  }
}> = ({ slots: { Header, CategoryMaps, Footer } }) => {
  return (
    <Layout
      slots={{
        Header,
        Main: (
          <Main
            slots={{
              CategoryMaps
            }}
          />
        ),
        Footer
      }}
    />
  )
}

export { Explore }

const Main: FC<{
  slots: {
    CategoryMaps: FC
  }
}> = ({ slots: { CategoryMaps } }) => {
  return (
    <Stack
      mt='calc(55px + env(safe-area-inset-top))'
      gap={6}
      mb={6}
    >
      <Box>
        <Typography
          component='h1'
          variant='next:h2'
          fontWeight={900}
          textAlign='center'
          mb={3}
        >
          Mapstack Gallery
        </Typography>
        <Typography
          component='p'
          variant='next:h5'
          textAlign='center'
          color='text.secondary'
          mb={3}
        >
          Mapstack magically turns data into interactive maps with AI. Explore
          the Gallery to see what the Mapstack team and community have been
          mapping.
        </Typography>
      </Box>
      <Box>
        <CategoryMaps />
      </Box>
    </Stack>
  )
}
